import React from "react";
import { getArealists } from "../../helpers/backend_helper";
import CodeList from "../Standards/CodeList";
import AreaDetail from "./AreaDetail";

const AreaList = ({ createRequest = 0 }) => (
  <CodeList
    createRequest={createRequest}
    listCodes={() => getArealists(true)}
    DetailComponent={AreaDetail}
    codeLabel="Checklist Area"
    codesLabel="Checklist Areas"
    categoryLabel="Checklist Configuration"
    searchPlaceholder="Search checklist areas..."
    fileName="checklist-areas"
  />
);

export default AreaList;
